<script lang="ts" setup>
import type { VisibleMagazineListItemModel } from '@develop/ia-api-library'

const NUMBER_OF_ARCHIVED_MAGAZINES_TO_DISPLAY = 25
const { t } = useTranslation()
const { getScripts } = useCdnUrl()
const page = ref(1)
const isLastPage = ref(false)
const magazineList = ref<VisibleMagazineListItemModel[]>([])

const { getMagazinePages, getArchiveMagazineList } = useEpaper()

definePageMeta({
  middleware: 'epaper',
})

const loadArchiveMagazines = async () => {
  const magazines = await getArchiveMagazineList(page.value)
  isLastPage.value = magazines.length < NUMBER_OF_ARCHIVED_MAGAZINES_TO_DISPLAY
  magazineList.value = [...magazineList.value, ...magazines]
}

await useAsyncData(
  'epaper:archive-magazines',
  loadArchiveMagazines,
  { default: () => [], watch: [page] },
)

const { initFlipbook } = useFlipbook()

const openMagazine = async (magazineId: number) => {
  const pages = await getMagazinePages(magazineId)
  initFlipbook(pages, `#magazine-${magazineId}`)
  // @ts-ignore jquery
  window.$(`#magazine-${magazineId}`).click()
}

const nextPage = () => page.value++
</script>

<template>
  <div>
    <link
      rel="stylesheet"
      type="text/css"
      :href="getScripts('flipbook/css/flipbook.style.css')"
    />
    <div flex="~ col gap-10">
      <div>
        <IaHeading
          :level="3"
          as="h1"
          font="!display 700"
        >
          {{ t('epaper.magazinePage.heading') }}
        </IaHeading>
        <IaParagraph
          mt-2
          color="grey-600"
        >
          {{ t('epaper.magazinePage.paragraph') }}
        </IaParagraph>
      </div>
      <div flex="~ col">
        <IaHeading
          :level="4"
          font-700
          mb="6"
        >
          {{ t('epaper.magazinePage.archiveTitle') }}
        </IaHeading>
        <div
          justify="evenly xl:initial"
          grid="~ gap-4 md:gap-5"
          class="grid-cols-[repeat(auto-fill,_170px)] sm:grid-cols-[repeat(auto-fill,_203px)]"
        >
          <EpaperMagazineCard
            v-for="magazine in magazineList"
            :key="magazine.id"
            active-border
            :magazine="magazine"
            @open-magazine="openMagazine"
          />
        </div>
        <IaButton
          v-if="!isLastPage"
          variant="outline"
          class="mx-auto mt-8 w-full sm:w-auto"
          @click="nextPage"
        >
          {{ t('epaper.magazinePage.loadMore') }}
        </IaButton>
      </div>
    </div>
  </div>
</template>
